import { fmtCurrency } from "../../lib/format";
import { Minus, Equal, Plus } from "lucide-react";

function Step({ label, value, tone = "neutral", strong }) {
  const color = tone === "neg" ? "text-brand-neg" : tone === "pos" ? "text-brand-pos" : tone === "highlight" ? "text-brand-page" : "text-brand-ink";
  return (
    <div className={`flex-1 min-w-[140px] px-5 py-4 ${tone === "highlight" ? "bg-brand-ink" : ""}`}>
      <p className={`text-[11px] uppercase tracking-[0.15em] ${tone === "highlight" ? "text-brand-page/60" : "text-brand-tertiary"}`}>{label}</p>
      <p className={`font-mono text-lg lg:text-xl mt-2 ${color} ${strong ? "font-medium" : ""}`}>{fmtCurrency(value)}</p>
    </div>
  );
}

function Op({ icon: Icon }) {
  return (
    <div className="flex items-center justify-center px-1 text-brand-tertiary">
      <Icon className="h-4 w-4" />
    </div>
  );
}

export default function BridgeCard({ totals, consolidated }) {
  return (
    <div className="bg-brand-surface border border-brand-border" data-testid="net-income-bridge">
      <div className="px-5 pt-5">
        <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">How Net Income is Derived</p>
        <p className="font-serif text-xl text-brand-ink mt-1">From location profit to your bottom line</p>
      </div>
      {consolidated ? (
        <div className="flex flex-wrap items-stretch mt-4 divide-x divide-brand-border border-t border-brand-border">
          <Step label="Location Net Income" value={totals.location_net_income} strong />
          <Op icon={Plus} />
          <Step label="Management Fee" value={totals.management_fee} tone="pos" />
          <Op icon={Equal} />
          <Step label="Net Income" value={totals.net_income} tone="highlight" strong />
        </div>
      ) : (
        <div className="flex flex-wrap items-stretch mt-4 divide-x divide-brand-border border-t border-brand-border">
          <Step label="Net Ordinary Income" value={totals.net_ordinary_income} strong />
          <Op icon={Minus} />
          <Step label="Legal / Bad Debt" value={totals.legal_bad_debt} tone="neg" />
          <Op icon={Minus} />
          <Step label="Corp Expense Allocation" value={totals.corp_expense_allocation} tone="neg" />
          <Op icon={Equal} />
          <Step label="Net Income" value={totals.net_income} tone="highlight" strong />
        </div>
      )}
      {consolidated && (
        <p className="px-5 pb-4 text-[11px] text-brand-tertiary">
          Each location's net income is already after its corporate expense allocation. The management fee (earned from corporate management contracts) is then added on top.
        </p>
      )}
    </div>
  );
}
